import { styled } from 'styled-components'
import Box from '@mui/material/Box'

export const StyledFormWrapper = styled(Box)`
 height: 100vh;
 background: white;
`
